import { useMutation } from "@tanstack/react-query";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserLoggedInData, getUserPermissionData } from "services/auth.services";
import { setAuthentication } from "store/authenticationSlice";

const useUser = () => {
  const dispatch = useDispatch();
  const userPermissionMutation = useMutation({
    mutationKey: ["permission", "get-permission"],
    mutationFn: getUserPermissionData, // Auth service login function
    onSuccess: (res) => {
      if (res) {
        const data = res.data;
        localStorage.setItem("permissions", JSON.stringify(data));
      }
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const userMutation = useMutation({
    mutationKey: ["auth", "login"],
    mutationFn: getUserLoggedInData, // Auth service login function
    onSuccess: (res) => {
      if (res) {
        const data = res.data;
        localStorage.setItem("workspaces", JSON.stringify(data.workspaces));
        localStorage.setItem("user", JSON.stringify(data.user));
        dispatch(setAuthentication(data));
        // userPermissionMutation.mutate();
      }
    },
    onError: (err) => {
      console.log(err);
    },
  });

  return { userMutation, userPermissionMutation };
};

export default useUser;
